// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__kXYUw","title":"AfterBackImages_title__Tpprq","images":"AfterBackImages_images__30YvO"};